<template>
    <div class="h-screen flex w-full">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <vx-card>
                <vs-row class="p-0" slot="no-body">
                    <vs-col class="text-center p-0 login-side-image" vs-xs="12" vs-sm="6" vs-lg="6">
                    </vs-col>
                    
                    <vs-col class="p-base" vs-xs="12" vs-sm="6" vs-lg="6">
                        <vs-row>
                            <vs-col class="text-center">
                                <img :src="logo" class="login-logo mx-auto" />
                                <h3 class="mb-2">Recover your password</h3>
                            </vs-col>
                            <vs-col class="mt-3">
                                <vs-input
                                    v-model="email"
                                    type="Email"
                                    label="Email*"
                                    placeholder="Enter your Email"
                                    class="w-full mb-3"
                                    :danger="api_errors.email ? true : false"
                                    :danger-text="api_errors.email ? api_errors.email.join(',') : null"
                                    @keydown="(e) => {e.keyCode == 13 ? submit() : null}"
                                    :disabled="submit_disabled"
                                />
                                <small>Please enter your email address and we'll send you instructions on how to reset your password.</small>
                            </vs-col>
                            <vs-col class="mt-3">
                                <vs-button 
                                    type="border" 
                                    :to="{name: 'page-login'}"
                                    class="float-left px-4 w-full md:w-auto" 
                                >Back To Login</vs-button>
                                <vs-button 
                                    @click="recover_password_button"
                                    class="float-right px-4 w-full md:w-auto" 
                                    :disabled="submit_disabled"
                                >Recover</vs-button>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </vx-card>
        </div>
    </div>
</template>

<script>

import { Request } from '../../utils/requests'

export default {
    data () {
        return {
            email: null,
            submit_disabled: false,
            api_errors: {}
        }
    },
    computed: {
        logo () {
            return require('@/assets/images/logo/logo.png')
        }
    },
    mounted () {
        this.$store.state.auth.isUserLoggedIn( res => {
            if (res) this.$router.push('/')
        })
    },
    methods: {
        recover_password_button () {
            this.submit_disabled = true

            const url = this.$store.state.apiendpoints.forgot_password 

            Request(this, 'POST', url, null, {email: this.email}, {}, false).then(
                () => {
                    this.submit_disabled = false
                    this.$router.push({name: 'page-login'})
                    this.$vs.notify({
                        time: 2500,
                        title: 'Email sent Successfully',
                        text: 'Please check your email and follow the instructions.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Request Failed',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'API Error',
                            text: 'An Error Occurred. Please try again later.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss">
    .login-logo {
        max-height: 50px;
    }
    .login-side-image {
        background-image: url('../../assets/images/pages/21.jpg');;
        background-size: cover;
        background-position: center;
    }
</style>